import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-view-driver-route",
  templateUrl: "./view-driver-route.component.html",
  styleUrls: ["./view-driver-route.component.css"],
})
export class ViewDriverRouteComponent implements OnInit {
  driverData: any;
  driver_Payment_Details: any = [];
  driver_Trip_History: any = [];
  driver_View_Notes: any;
  driverTax: any;
  driver_Trip_Details: any;
  cancel_button: boolean = false;
  NotesData: any;
  calculatedTax: any = "";
  transporter_details: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private MatDialog: MatDialog,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private matdialogRef: MatDialogRef<ViewDriverRouteComponent>
  ) {
    this.driverData = data;
    this.transporter_details = this.driverData?.truckownerPaymentInfo || [];

    this.driver_Payment_Details.push(
      data.trip_payment_info[0]?.price_details?.payment_history
    );
    this.driver_Trip_History.push(data.trip_details?.trip_history);
    this.driver_View_Notes = data.notes_details;
    this.driverTax = data.tax_details.filter(
      (value: any, index: any, self: any) =>
        index ===
        self.findIndex(
          (t: any) =>
            t.tax_name === value.tax_name &&
            t.tax_deduction === value.tax_deduction
        )
    );

    this.driver_Trip_Details = data.trip_details[0]?.trip_history;
  }

  ngOnInit(): void {
    this.GetNotes();
    this.calculateAndFormatTax();
  }

  getPaymentLabel(index: number): string {
    if (index === 1) return "1st";
    if (index === 2) return "2nd";
    if (index === 3) return "3rd";
    return index + "th";
  }

  calculateAndFormatTax(): void {
    if (this.data.tax_details && this.data.tax_details[0]) {
      const actualPrice = this.data.route_fare;
      const taxDeduction = this.data.tax_details[0].tax_deduction;
      const tax = (actualPrice * taxDeduction) / 100;
      this.calculatedTax = this.formatNumber(tax);
    }
  }

  formatNumber(value: number): string {
    return Math.floor(value).toString();
  }

  public GetNotes() {
    let token = localStorage.getItem("adminToken");
    this.services.GetNotes(this.data._id, token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.NotesData = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          // this.matDialogref.close();
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          // this.matDialogref.close();
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          // this.matDialogref.close();
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  getTotalFare(): number {
    let baseFare = 0;

    // If trip_status is "pending", return 0.00
    if (this.driverData?.bidDetails[0]?.trip_status === "pending") {
      return 0.0;
    }

    if (
      this.driverData.workorderInfo[0]?.pay_as_load_quantity ===
      "loaded_quantity"
    ) {
      baseFare =
        (this.driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
        (this.driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0);
    } else if (
      this.driverData.workorderInfo[0]?.pay_as_load_quantity ===
      "unloaded_quantity"
    ) {
      const qty = this.driverData.tripInfo?.workOrderOtherDetails?.unloading_point || this.driverData.tripInfo?.workOrderOtherDetails?.loading_point;
      baseFare =
        (this.driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
        (qty || 0);
    } else {
      baseFare = 0.0; // Default to 0.00 if trip_status is "pending"
    }

    // Calculate total tax deduction
    let totalTax = this.driverTax.reduce((acc: number, item: any) => {
      let taxAmount =
        item.tax_type === "percent"
          ? (baseFare * item.tax_deduction) / 100
          : item.tax_deduction;
      return acc + (taxAmount || 0);
    }, 0);
    console.log("baseFare", baseFare);
    console.log("totalTax", totalTax);
    

    return baseFare - totalTax;
  }

  // getTotalFare(): number {
  //   let baseFare = 0;

  //   // If trip_status is "pending", return 0.00
  //   if (this.driverData?.bidDetails[0]?.trip_status === "pending") {
  //     return 0.0;
  //   }

  //   if (
  //     this.driverData.workorderInfo?.[0]?.pay_as_load_quantity ===
  //     "loaded_quantity"
  //   ) {
  //     baseFare =
  //       (this.driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
  //       (this.driverData.tripInfo?.workOrderOtherDetails?.loading_point || 0);
  //   } else if (
  //     this.driverData.workorderInfo?.[0]?.pay_as_load_quantity ===
  //     "unloaded_quantity"
  //   ) {
  //     baseFare =
  //       (this.driverData.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
  //       (this.driverData.tripInfo?.workOrderOtherDetails?.unloading_point || 0);
  //   }

  //   // If baseFare is 0, return ptotal_fare
  //   if (!baseFare) {
  //     return this.driverData?.total_fare || 0;
  //   }

  //   // Calculate total tax deduction
  //   let totalTax =
  //     this.driverTax?.reduce((acc: number, item: any) => {
  //       let taxAmount =
  //         item.tax_type === "percent"
  //           ? (baseFare * item.tax_deduction) / 100
  //           : item.tax_deduction;
  //       return acc + (taxAmount || 0);
  //     }, 0) || 0;

  //   return baseFare - totalTax;
  // }

  close() {
    this.matdialogRef.close();
  }
  consignment(data: any) {}
  
  cancelTrip(id: string): void {
    let token = localStorage.getItem("adminToken");
    const cancelPayload = {
      reason: "Cancelled by admin from DRO panel",
      cancelled_by: "admin",
    };
    this.services.cancleTrip(cancelPayload, token, id).subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.matdialogRef.close(); // Close the current dialog
          location.reload(); // Reload to reflect cancellation
          this.snackBar.open(response.body?.message || "DRO cancelled", "Success", {
            duration: 5000,
          });
        }
      },
      error: (error: any) => {
        this.snackBar.open(error.error?.message || "DRO Cancellation failed", "Fail", {
          duration: 5000,
        });
      }
    });
  }

}
